import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import apiCall from "auth/ApiCallInstance"; // your axios instance

const Ctx = createContext(null);
export const useAdminNotifications = () => useContext(Ctx);

export function AdminNotificationsProvider({ children }) {
  const [items, setItems] = useState([]);

  const fetchLatest = useCallback(async () => {
    const r = await apiCall.get("/admin-notifications?limit=50");
    setItems(r.data || []);
  }, []);

  useEffect(() => {
    fetchLatest().catch(console.error);
  }, [fetchLatest]);

  const addFromWs = useCallback((payload) => {
    if (!payload) return;
    setItems((prev) => {
      if (payload._id && prev.some((p) => p._id === payload._id)) return prev;
      const n = {
        _id: payload._id,
        title: payload.title,
        body: payload.body,
        url: payload.url,
        createdAt: payload.createdAt || new Date().toISOString(),
        isRead: false,
        event: payload.event,
        type: payload.type || "system",
      };
      return [n, ...prev].slice(0, 200);
    });
  }, []);

  const markRead = useCallback(async (id) => {
    setItems((prev) => prev.map((n) => n._id === id ? { ...n, isRead: true } : n));
    try {
      await apiCall.post(`/admin-notifications/${id}/read`);
    } catch (e) {
      console.error(e);
      // rollback if needed
      setItems((prev) => prev.map((n) => n._id === id ? { ...n, isRead: false } : n));
    }
  }, []);

  const markAllRead = useCallback(async () => {
    setItems((prev) => prev.map((n) => ({ ...n, isRead: true })));
    await apiCall.post("/admin-notifications/read-all");
  }, []);

  const clearAll = useCallback(async () => {
    setItems([]);
    await apiCall.delete("/admin-notifications/clear");
  }, []);

  const value = useMemo(() => ({
    items,
    unreadCount: items.filter((i) => !i.isRead).length,
    addFromWs,
    fetchLatest,
    markRead,
    markAllRead,
    clearAll,
  }), [items, addFromWs, fetchLatest, markRead, markAllRead, clearAll]);

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}
